"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductBuilderModal = void 0;
const React = require("react");
const react_1 = require("react");
const Modal_1 = require("../../../../../components/base/structure/Modal");
const dialogs_1 = require("../../../../../types/dialogs");
const ProductBuilder_1 = require("../../atoms/ProductBuilder");
const cloneModelObject_1 = require("../../../../../apis/spg/util/cloneModelObject");
const ProductBuilderFooter_1 = require("./ProductBuilderFooter");
const ProductBuilderHeader_1 = require("./ProductBuilderHeader");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "ProductBuilderModal");
const PRODUCT_BUILDER_MODAL_ID = "productBuilderModal";
/**
 * Modal style user interface where one can customise a blueprint product
 * and add the finalised build to his sales order.
 */
const ProductBuilderModal = ({ salesOrderItemBuilt, isExisting = false, onCompletion }) => {
    const [salesOrderItem, setSalesOrderItem] = (0, react_1.useState)(salesOrderItemBuilt);
    (0, react_1.useEffect)(() => {
        setSalesOrderItem(salesOrderItemBuilt);
    }, [salesOrderItemBuilt]);
    // whether product builder is open
    const open = (0, react_1.useMemo)(() => !!salesOrderItem, [salesOrderItem]);
    // helper function to scroll builder to given category
    const scrollToCategory = (category) => {
        const modalEl = document.getElementById(PRODUCT_BUILDER_MODAL_ID);
        const categoryEl = document.getElementById(category);
        const header = document.getElementsByClassName("ProductBuilderHeader")[0];
        const headerHeight = header.clientHeight;
        const top = categoryEl.offsetTop - headerHeight;
        const scrollOptions = {
            top,
            behavior: "smooth"
        };
        modalEl.scrollTo(scrollOptions);
        modalEl.parentElement.scrollTo(scrollOptions);
    };
    (0, react_1.useEffect)(() => {
        if (!salesOrderItem) {
            return;
        }
        const header = document.getElementsByClassName("ProductBuilderHeader")[0];
        const body = document.getElementsByClassName("ProductBuilderModal_body")[0];
        const headerHeight = header.clientHeight;
        body.style.marginTop = `${headerHeight}px`;
    }, [salesOrderItem]);
    return (React.createElement(Modal_1.Modal, { modalId: PRODUCT_BUILDER_MODAL_ID, closeIconId: "ProductBuilderHeader_closeIcon", open: open, size: dialogs_1.TDialogSizes.Large, appMode: true, sticky: true, onClose: () => onCompletion(null), className: css("modal") }, open && (React.createElement(React.Fragment, null,
        React.createElement(ProductBuilderHeader_1.ProductBuilderHeader, { salesOrderItemBuilt: salesOrderItem, scrollToCategory: scrollToCategory }),
        React.createElement(Modal_1.ModalBody, { className: css("body") },
            React.createElement(ProductBuilder_1.ProductBuilder, { salesOrderItem: salesOrderItem, onChange: () => setSalesOrderItem((0, cloneModelObject_1.cloneModelObject)(salesOrderItem)) })),
        React.createElement(ProductBuilderFooter_1.ProductBuilderFooter, { salesOrderItemBuilt: salesOrderItem, onCompletion: onCompletion, isExisting: isExisting, scrollToCategory: scrollToCategory, setSalesOrderItem: setSalesOrderItem })))));
};
exports.ProductBuilderModal = ProductBuilderModal;
//# sourceMappingURL=index.js.map